export const LOADED = 'LOADED'
export const LOADING = 'LOADING'
export const PLAYING = 'PLAYING'
export const PAUSED = 'PAUSED'
export const STOPPED = 'STOPPED'
export const SEEKING = 'SEEKING'
